import { useContext } from "react";
import VocReportContext from "../context/vocReportProvider";

const VocReportTabs = () => {
  const { tabs, setTabs } = useContext(VocReportContext);

  return {
    tabs,
    setTabs,
  };
};

export default VocReportTabs;
